


































import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Ware, WareDetection } from "./ware.interface";
import _debounce from "lodash/debounce";
@Component
export default class ApkDetectionTable extends Vue {
  @Prop({ required: true }) apk;
  @Prop({ required: true }) packageName;

  RESULT_COLOR_MAP = {
    排队中: "primary",
    检测中: "warning",
    成功: "success",
    失败: "danger"
  };
  @Watch("search") onSearch(val: string) {
    this.searchDebounce();
  }
  @Watch("apk", { immediate: true }) onApkChange(val) {
    if (val) {
      this.visibleList = val;
    }
  }
  @PropSync("search") searchString!: string;

  visibleList: WareDetection[] = [];
  searchDebounce = _debounce(this.onFilter, 200);

  typeFilters = [
    {
      text: "手动检测",
      value: "manual"
    },
    {
      text: "自动化检测",
      value: "auto"
    }
  ];

  resultFilters = ["成功", "失败", "排队中", "检测中"].map(item => ({
    text: item,
    value: item
  }));

  declareFilters = [
    {
      text: "有",
      value: true
    },
    {
      text: "无",
      value: false
    }
  ];

  filterHandler(value: any, row: any, column: any) {
    const property = column["property"];
    return row[property] === value;
  }

  encryptionFormatter(row: any, column: any, cellValue: any) {
    return cellValue ? "是" : "否";
  }

  typeFormatter(row: any, column: any, cellValue: any) {
    switch (cellValue) {
      case "manual":
        return "手动检测";
      case "auto":
        return "自动化检测";
    }
  }

  onFilter() {
    if (this.apk) {
      this.visibleList = this.apk.filter(item =>
        new RegExp(this.searchString, "i").test(item.developerID)
      );
    } else {
      this.visibleList = [];
    }
  }

  onCheck(row) {
    let id = row.id;
    let packageName = this.$route.params.id;
    this.$router.push({
      name: "ware-packageName",
      query: {
        id: row.id,
        packageName: packageName
      },
      params: {
        name: "开发者申报"
      }
    });
  }

  onCheckTag(row: WareDetection) {
    this.$router.push({
      name: "report-apk-id",
      params: {
        id: row.id
      }
    });
  }

  isReportLinkEnabled(row: WareDetection) {
    // return row.result === "成功" || row.result === "失败";
  }
}
